
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Router, Route, Switch, useLocation } from "wouter";
import { useEffect } from "react";
import Index from "./pages/Index";
import Creators from "./pages/Creators";
import Businesses from "./pages/Businesses";
import Legal from "./pages/Legal";
import Contact from "./pages/Contact";
import Newsroom from "./pages/Newsroom";
import ThankYouCreator from "./pages/ThankYouCreator";
import ThankYouBusiness from "./pages/ThankYouBusiness";
import ThankYouContact from "./pages/ThankYouContact";
import NotFound from "./pages/NotFound";

// Arabic pages
import IndexAr from "./pages/ar/IndexAr";
import CreatorsAr from "./pages/ar/CreatorsAr";
import BusinessesAr from "./pages/ar/BusinessesAr";
import LegalAr from "./pages/ar/LegalAr";
import ContactAr from "./pages/ar/ContactAr";
import NewsroomAr from "./pages/ar/NewsroomAr";
import PrivacyPolicies from "./pages/PrivacyPolicies";
import TermOfUse from "./pages/TermOfUse";
import KnowledgeHub from "./pages/KnowledgeHub";

const queryClient = new QueryClient();

function ScrollToTop() {
  const [location] = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  
  return null;
}

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <Router>
        <ScrollToTop />
        <Switch>
          <Route path="/" component={Index} />
          <Route path="/creators" component={Creators} />
          <Route path="/businesses" component={Businesses} />
          <Route path="/newsroom" component={Newsroom} />
          <Route path="/legal" component={Legal} />
          <Route path="/contact" component={Contact} />
          <Route path="/thank-you-creator" component={ThankYouCreator} />
          <Route path="/thank-you-business" component={ThankYouBusiness} />
          <Route path="/thank-you-contact" component={ThankYouContact} />
          
          <Route path="/privacy-policy" component={PrivacyPolicies} />
          <Route path="/term-of-use" component={TermOfUse} />
          <Route path="/knowledge-hub" component={KnowledgeHub} />


          {/* Arabic routes */}
          <Route path="/ar" component={IndexAr} />
          <Route path="/ar/creators" component={CreatorsAr} />
          <Route path="/ar/businesses" component={BusinessesAr} />
          <Route path="/ar/newsroom" component={NewsroomAr} />
          <Route path="/ar/legal" component={LegalAr} />
          <Route path="/ar/contact" component={ContactAr} />
          
          <Route component={NotFound} />
        </Switch>
      </Router>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
